(ns app.front.view.form-util
  (:require [app.front.form.subs :as form-subs]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))


(defn update-form-disabled?
  [{:keys [target-id form-id form-field disabled? update-field-signal delete-field? preview?]} attr]
  (and (not preview?)
       (or disabled?
           (true? (:disabled attr))
           (not (<sub [:app.front.process/signal-permitted?
                       target-id
                       [(or update-field-signal :process.signal/update-form-data)
                        {:form-field-id (:db/id form-field)
                         :field-key     (:field attr)
                         :form-id       form-id
                         :delete-field? delete-field?}]])))))


(rf/reg-event-fx ::update-form-field.success
  (fn [_ [_ form-id original-on-success status body]]
    {:fx (cond-> [[:dispatch [::form-subs/refresh-form-field-info form-id]]]
           original-on-success (conj [:dispatch (into original-on-success [status body])]))}))

(rf/reg-event-fx ::update-form-field.done
  (fn [_ [_ form-id token operation-id original-on-done status body]]
    {:fx (cond-> [[:dispatch [::form-subs/finish-field-edit form-id token operation-id]]]
           original-on-done (conj [:dispatch (into original-on-done [status body])]))}))

(rf/reg-event-fx
  ::update-form-field
  (fn [{:keys [db]} [_ target-id {:keys [form-id form-field-id] :as params} & [signal-opts]]]
    ;; Prevent dispatch in form editor preview mode by checking that we have a target
    (when target-id
      (let [operation-id (random-uuid)
            token        (form-subs/update-field-token db params)
            params       (if form-field-id
                           params
                           (dissoc params :form-field-id))
            opts         (-> signal-opts
                             (assoc :on-success [::update-form-field.success form-id (:on-success signal-opts)])
                             (assoc :on-done [::update-form-field.done form-id token operation-id (:on-done signal-opts)])
                             (assoc :on-error [::update-form-field.done form-id token operation-id
                                               (:on-error signal-opts)])
                             (assoc :track-save? true))]
        {:db (form-subs/track-field-edit db params operation-id)
         :fx [[:dispatch [:app.front.process/signal
                          target-id
                          [:process.signal/update-form-data params]
                          opts]]]}))))


(defn download-url
  ([application-id role-id]
   (download-url application-id role-id nil false false))
  ([application-id role-id party-id manual-sign-off? save]
   (cond-> (str "/api/command/sign-off/download?application-id=" application-id "&role-id=" role-id)
     party-id (str "&party-id=" party-id)
     manual-sign-off? (str "&manual-sign-off=true")
     save (str "&save=true"))))
